import React, { Fragment, memo } from 'react'

import { useUnit } from 'effector-react'

import { Typo } from 'components/_old/Typo'

import { Paper } from 'components/atoms/Paper'
import { type SecurityLogoSizes } from 'components/atoms/SecurityLogo'
import { Stack } from 'components/atoms/Stack'
import { Typography } from 'components/atoms/Typography'

import { $displayedProviders } from '../../model'

import { AvailableToTransferFromProvider } from './AvailableToTransferFromProvider'

const AvailableToTransferFrom = memo(({ logoSize }: { logoSize?: SecurityLogoSizes }): React.ReactElement => {
  const displayedProviders = useUnit($displayedProviders)

  return (
    <Fragment>
      <Typography size={24} weight="semibold" lineHeight="small">
        <Typo>Available to transfer from</Typo>
      </Typography>
      <Paper top={32}>
        <Stack horizontal={24}>
          {displayedProviders.map((provider) => (
            <AvailableToTransferFromProvider key={provider.name} provider={provider} logoSize={logoSize} />
          ))}
        </Stack>
      </Paper>
    </Fragment>
  )
})
AvailableToTransferFrom.displayName = 'AvailableToTransferFrom'

export { AvailableToTransferFrom }
